import cx from 'classnames';
import type { FC, PropsWithChildren, ReactNode, RefObject } from 'react';
import { useLayoutEffect, useRef } from 'react';

import { WIZARD_ZINDEX } from '@zen/Layout';
import type { Nullable } from '@zen/utils/typescript';

import type { WizardStep } from '../../types';

interface Props {
  footer: ReactNode;
  masthead: ReactNode;
  stepId: WizardStep;
  stepper: ReactNode;
}

const WizardLayout: FC<PropsWithChildren<Props>> = (props) => {
  const { children, footer, masthead, stepId, stepper } = props;
  const contentRef: RefObject<Nullable<HTMLElement>> = useRef<HTMLElement>(null);

  useLayoutEffect((): void => {
    const { current: content } = contentRef;

    if (!content) {
      return;
    }

    content.scrollTop = 0;
  }, [stepId]);

  const classNames: string = cx('fixed inset-0 flex flex-col bg-white', WIZARD_ZINDEX);

  return (
    <div className={classNames} data-component="wizard-layout">
      {masthead}
      {stepper}
      <main className="js-element-scrollable flex-1 overflow-y-auto" ref={contentRef}>
        <div className="mx-auto w-full max-w-6xl px-6 py-8">{children}</div>
      </main>
      {footer}
    </div>
  );
};

export type { Props as WizardLayoutProps };
export default WizardLayout;
